import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {FeedExportPlatformImage} from "../FeedExportSettings/FeedExportPlatformImage";

const PlatformColumn = memo(({feedExport}) => (
  <td className={'feed_export_item'}>
    <FeedExportPlatformImage platform={feedExport.mapping.platform} status={feedExport.status}/>
  </td>
));

PlatformColumn.propTypes = {
  feedExport: PropTypes.object.isRequired,
};

export default PlatformColumn;
